module.exports = __webpack_public_path__ + "img/FigmaDDSSlicePNG625fc3f44069905c6e44a277b887831f.625fc3f4.png";